// The text a catalogue from `__obj` holds for `key`. The catalogue carries only
// the keys the locale files declare, and a declared key can hold a nested table
// rather than text, so either reads as `fallback`. That defaults to the key
// itself, which keeps a label on the element rather than leaving it empty.
export function translationLabel(
  catalogue: Record<string, I18nTranslation | undefined>,
  key: string,
  fallback: string = key
): string {
  const translation = catalogue[key];
  return typeof translation === 'string' ? translation : fallback;
}
